/* istanbul ignore file */

export const RELATED_CATEGORIES_TITLE = 'You may also like';
